import { useMemo } from 'react';

import { TEAM_MEMBER_STATUS, type TeamMemberStatus } from '@ekhodealer/ekho-common';

import { PLACEHOLDER } from '@common/lib/strings';

import { useSearchTeamMembers } from '../api/useSearchTeamMembers';

/**
 * Hook to fetch and calculate team member counts for each tab.
 * Returns a function to get the count for a specific tab as a string.
 * PLACEHOLDER is returned while loading, a number string for actual count.
 */
export function useTeamTableTabCounts(): (tab: TeamMemberStatus) => string {
	// Fetch counts for all statuses (no status filter, limit 0 = counts only)
	const { data, isPending } = useSearchTeamMembers({
		limit: 0,
		page: 0,
	});

	const getTabCount = useMemo(() => {
		return (tab: TeamMemberStatus): string => {
			if (isPending) {
				return PLACEHOLDER;
			}

			const statusCounts =
				(data?.facets as Record<string, Record<string, number>> | undefined)
					?.statusCounts ?? {};
			const totalCount = data?.count ?? 0;

			if (tab === TEAM_MEMBER_STATUS.ALL) {
				return totalCount.toLocaleString();
			}
			return (statusCounts[tab] ?? 0).toLocaleString();
		};
	}, [data, isPending]);

	return getTabCount;
}
